import React from 'react';
 import { Route, Redirect } from 'react-router-dom';
 
function PrivateRoute({ component: Component, ...rest }) {
  
  return (<>
    {rest.isAuthenticated && (
      <Route>
        <Component {...Component}  />
      </Route>
    )}
    {!rest.isAuthenticated && (
      <Route>
        <Redirect to={{ pathname: rest.redirectPath }} />
      </Route>
    )}

    {/* <Route
      {...rest}
      render={(props) => rest.isAuthenticated ? <Component {...Component} /> : <Redirect to={{ pathname: rest.redirectPath, state: { from: props.location } }} />}
    /> */}
  </>)
}

export default PrivateRoute;